export default __webpack_public_path__ + "static/media/device-pulse.064cdb0f.png";